/**
 * Central translation registry.
 *
 * Add new product translation modules here:
 *   1. Import the En + Fr objects from their file.
 *   2. Spread them into the `en` and `fr` locale blocks below.
 *
 * The resulting `messages` object is consumed directly by VueI18n in src/i18n.ts.
 */

import { globalsEn, globalsFr } from './globals';
import { modalsEn, modalsFr } from './modals';
import { promotionsEn, promotionsFr } from './promotions';
import { maintenanceEn, maintenanceFr } from './maintenance';
import { dataTableFieldsEn, dataTableFieldsFr } from './data-table-fields';
import { staticSelectEn, staticSelectFr } from './static-select-options';
import { customTrackingEn, customTrackingFr } from './custom-tracking';
import { companySettingsEn, companySettingsFr } from './company-settings';
import { propertyMediaEn, propertyMediaFr } from './property-media';
import { customFieldsEn, customFieldsFr } from './custom-fields';
import { customContentEn, customContentFr } from './custom-content-mixin';
import { callTrackingEn, callTrackingFr } from './call-tracking';
import { ivrEn, ivrFr } from './ivr';
import { reportingEn, reportingFr } from './reporting';
import { toursSettingsEn, toursSettingsFr } from './tours-settings';
import { websiteEn, websiteFr } from './website';
import { formSettingsEn, formSettingsFr } from './form-settings';
import { toursEn, toursFr } from './tours';
import { amenitiesEn, amenitiesFr } from './amenities';
import { billingEn, billingFr } from './billing';
import { unitMediaEn, unitMediaFr } from './unit-media';
import { userManagementEn, userManagementFr } from './user-management';
import { listingManagementEn, listingManagementFr } from './listing-management';
import { connectionsEn, connectionsFr } from './connections';
import { marketInsightsEn, marketInsightsFr } from './market-insights';

export const messages = {
  en: {
    ...amenitiesEn,
    ...billingEn,
    ...companySettingsEn,
    ...customContentEn,
    ...customFieldsEn,
    ...callTrackingEn,
    ...customTrackingEn,
    ...dataTableFieldsEn,
    ...globalsEn,
    ...ivrEn,
    ...maintenanceEn,
    ...modalsEn,
    ...marketInsightsEn,
    ...promotionsEn,
    ...propertyMediaEn,
    ...reportingEn,
    ...staticSelectEn,
    ...toursEn,
    ...toursSettingsEn,
    ...unitMediaEn,
    ...websiteEn,
    ...formSettingsEn,
    ...userManagementEn,
    ...listingManagementEn,
    ...connectionsEn,
  },
  fr: {
    ...amenitiesFr,
    ...billingFr,
    ...companySettingsFr,
    ...customContentFr,
    ...customFieldsFr,
    ...callTrackingFr,
    ...customTrackingFr,
    ...dataTableFieldsFr,
    ...globalsFr,
    ...ivrFr,
    ...maintenanceFr,
    ...modalsFr,
    ...marketInsightsFr,
    ...promotionsFr,
    ...propertyMediaFr,
    ...reportingFr,
    ...staticSelectFr,
    ...toursFr,
    ...toursSettingsFr,
    ...unitMediaFr,
    ...websiteFr,
    ...formSettingsFr,
    ...userManagementFr,
    ...listingManagementFr,
    ...connectionsFr,
  },
};

export type TMessages = typeof messages;
